import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

export const organizerCommonStoreSelector = (state: RootState) => state.organizer;

export const organizerIsLoadingSelector = createSelector(organizerCommonStoreSelector, (state) => state.isLoading);
export const organizerIsLoadedSelector = createSelector(organizerCommonStoreSelector, (state) => state.isLoaded);
export const organizerIsTeamCreatingSelector = createSelector(organizerCommonStoreSelector, (state) => state.isTeamCreating);
export const organizerInfoSelector = createSelector(organizerCommonStoreSelector, (state) => state.info);
export const organizerIsTeamEditingSelector = createSelector(organizerCommonStoreSelector, (state) => state.isTeamEditing);
export const organizerIsSavingSelector = createSelector(organizerCommonStoreSelector, (state) => state.isSaving);
